module.exports = __webpack_public_path__ + "images/services/github.8cab38550d1f23032fac.png";